import { AppSyncFarmToken } from 'common/models/farm';
import React from 'react';
import { NumberUtils } from 'utils/numberUtils';
import FormatNumber from '../FormatPercent/FormatNumber';
import SpinnerContainer from '../SpinnerContainer';

type Props = {
  token: AppSyncFarmToken;
  availableToken: bigint;
  tokenPrice: number;
  isLoading: boolean;
  isDepositing: boolean;
  amount: string;
  type?: string;
  tokenDisplayName?: string;
  onChange: (value: string) => void;
};

const TokenBalance: React.FC<Props> = (props) => {
  const baseToken = props.token;
  return (
    <div className="flex flex-row justify-end items-center">
      <div className="flex flex-row justify-start font-medium gap-2">
        Balance
        <SpinnerContainer isLoading={props.isLoading}>
          <FormatNumber
            value={NumberUtils.BNtoNumberWithoutDecimals(
              props.availableToken.toString(),
              baseToken ? baseToken.decimals : 18
            )}
            prefix=""
            displayDecimals={NumberUtils.determineDecimals(props.amount)}
            isLoading={false}
            useNumbro={true}
            className="primary-text-color font-semibold"
          />
        </SpinnerContainer>
      </div>
      <button
        className="secondary-button rounded-full py-1 ml-3 font-semibold text-sm"
        onClick={() =>
          props.onChange(
            NumberUtils.BNtoStringWithoutDecimals(
              props.availableToken,
              baseToken ? baseToken.decimals : 18
            )
          )
        }
      >
        Max
      </button>
    </div>
  );
};

export default TokenBalance;
